import { useField } from "formik";
import { DatePicker } from "kubra-ux-forge";
import React from "react";
import { setTimeToZero } from "../utils";

interface DateFieldProps {
  name: string;
  label: string;
  placeholder?: string;
  editableIfPrefilled?: boolean;
  min?: string;
  max?: string;
}

export const DateField: React.FC<DateFieldProps> = ({
  name,
  label,
  placeholder,
  editableIfPrefilled,
  min,
  max,
}) => {
  const [field, meta, helpers] = useField(name);

  let disabled = false;

  if (meta.initialValue && !editableIfPrefilled) {
    disabled = true;
  }

  const handleDateChange = (selectedDate: Date | Date[]) => {
    if (selectedDate instanceof Date) {
      helpers.setValue(selectedDate.toISOString());
    } else if (Array.isArray(selectedDate) && selectedDate.length > 0) {
      helpers.setValue(selectedDate[0].toISOString());
    }
  };

  return (
    <div className="date-field-container" aria-invalid={meta.touched && !!meta.error}>
      <DatePicker
        {...field}
        onChange={handleDateChange}
        errorText={meta.touched ? meta.error : undefined}
        hasError={meta.touched ? !!meta.error : false}
        label={label}
        value={field.value ? new Date(field.value) : undefined}
        placeholder={placeholder}
        dataCy={name}
        disabled={disabled}
        {...(min ? { minDate: setTimeToZero(new Date(min)) } : null)}
        {...(max ? { maxDate: setTimeToZero(new Date(max)) } : null)}
      />
    </div>
  );
};
